import { maskitoUpdateElement } from '@maskito/core';
import { maskitoEventHandler, maskitoTimeOptionsGenerator } from '@maskito/kit';
import { useMaskito } from '@maskito/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeftToArc,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import { Input, InputProps } from '@e2n/ui';

interface TimeInputProps extends InputProps {
  icon?: IconDefinition;
  className?: string;
  onClick?: () => void;
  applyValue?: boolean;
  schichtUpdate?: boolean;
}
const timeOptions = maskitoTimeOptionsGenerator({
  mode: 'HH:MM',
  timeSegmentMaxValues: { hours: 23 },
});

const options = {
  ...timeOptions,
  plugins: [
    ...timeOptions.plugins,
    maskitoEventHandler('blur', (element) => {
      const [hours = '', minutes = ''] = element.value.split(':');

      if (hours === '' && minutes === '') {
        return;
      }

      maskitoUpdateElement(
        element,
        [hours, minutes].map((segment) => segment.padEnd(2, '0')).join(':'),
      );
    }),
  ],
};

export function TimeInput({
  applyValue,
  className,
  schichtUpdate = false,
  ...props
}: TimeInputProps) {
  const maskedInputRef = useMaskito({ options });

  return (
    <div className="relative">
      <Input
        ref={maskedInputRef}
        {...props}
        className={`${applyValue ? 'ps-7' : 'text-center'} ${className}`}
      />
      {applyValue && (
        <>
          {schichtUpdate && (
            <FontAwesomeIcon
              icon={faArrowLeftToArc}
              onClick={props.onClick}
              className={` hover:text-primary-blue-700 absolute left-2 top-1/2 -translate-y-1/2 cursor-pointer text-primary-blue-600`}
            />
          )}
          {!schichtUpdate && (
            <FontAwesomeIcon
              icon={faArrowLeftToArc}
              className={`  absolute left-2 top-1/2 -translate-y-1/2 text-neutrals-600 cursor-not-allowed`}
            />
          )}
        </>
      )}
    </div>
  );
}
